import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UploadCSRCService } from "../../shared/services/upload-csrc/upload-csrc.service";
import Swal from "sweetalert2";
import { first } from "rxjs/operators";

@Component({
  selector: "app-csrc",
  templateUrl: "./csrc.component.html",
  styleUrls: ["./csrc.component.scss"]
})
export class CSRCListComponent implements OnInit {
  filter: any = {
    key: ""
  };
  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  csrcCount = 0;
  doc: any;
  downloadurl = "";
  /** end pagination */
  csrc: any = [];
  sender = "csrc";

  constructor(
    private router: Router,
    private uploadCsrcService: UploadCSRCService
  ) { }

  ngOnInit() {
    this.searchUploadCsrcList();
  }

  uploadCsrc() {
    this.router.navigate(["manager/csrc/upload"]);
  }

  OnClick(id) {
    this.router.navigate(["manager/csrc-detail/" + id]);
  }

  onAdd() {
    this.router.navigate(["manager/csrc-detail/new"]);
  }

  searchUploadCsrcList() {
    this.uploadCsrcService
      .searchCsrc(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe(res => {
        this.csrcCount = res["count"];
        this.csrc = res["data"];
      });
  }

  fetchexamData(e) {
    this.currentPage = e;
    this.searchUploadCsrcList();
  }


  clear() {
    this.filter.key = "";
    this.searchUploadCsrcList();
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text: "CSRC data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "CSRC is deleted.", "success");
        this.uploadCsrcService
          .deleteAll(this.csrc)
          .pipe(first())
          .subscribe(res => {
            this.searchUploadCsrcList();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "CSRC is Not Deleted:)", "error");
      }
    });
  }
}
